import useAudioStore from '@/store/useAudioStore';
import { Volume1, Volume2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { colors } from '@/constant/colors';

const Volume = ({ color = colors.themeColor }: { color?: string }) => {
  const isPlaying = useAudioStore((state) => state.isPlaying);
  const isMuted = useAudioStore((state) => state.isMuted);
  const [isVolume2, setIsVolume2] = useState(true);

  // 交替显示 Volume1 和 Volume2
  useEffect(() => {
    if (isMuted) return; // 如果静音，不需要动画
    
    const interval = setInterval(() => {
      setIsVolume2(prev => !prev);
    }, 500); // 每500ms切换一次
    
    return () => clearInterval(interval);
  }, [isMuted]);
  
  if (isMuted || !isPlaying) return null

  return (
    <div>
      {(
        isVolume2 ? (
          <Volume2 className='w-4 h-4' style={{ color }} />
        ) : (
          <Volume1 className='w-4 h-4' style={{ color }} />
        )
      )}
    </div>
  )
}

export default Volume;